import { useOAIQuery } from '~/hooks/reactQuery';
import type { CART_TYPE } from '~/hooks/useCartTypeParam';
import { fetchOAIData } from '~/libs/openapi';

import { getSnowdonJwt } from '../auth/utils';

/**
 * @description
 * 유저의 포인트 내역 조회
 * 포인트 내역 + 포인트로 구매 가능한 쿠폰 리스트
 * */
export const usePointSearch = () => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/buyer/point',
  });
};

export const useAvailablePoint = (
  cartType: CART_TYPE,
  buyerCouponIds: number | null,
) => {
  return useOAIQuery({
    queryKey:
      '/api/market-place/v1/shopping-cart/checkout/maximum-available-point',
    variables: {
      cartType,
      buyerCouponIds: buyerCouponIds ? [buyerCouponIds] : [],
    },
  });
};

export const fetchAvailablePoint = (
  cartType: CART_TYPE,
  buyerCouponIds: number | null,
) => {
  return fetchOAIData({
    queryKey:
      '/api/market-place/v1/shopping-cart/checkout/maximum-available-point',
    variables: {
      cartType,
      buyerCouponIds: buyerCouponIds ? [buyerCouponIds] : [],
    },
    fetchOptions: {
      headers: {
        'X-Client-Auth-Token': getSnowdonJwt(),
      },
    },
  });
};
